import { UseMutationResult } from 'react-query';
import { editorService } from '../../../services';
import { useProjectTagMutation } from './use-project-tag-mutation';

export function useProjectTagCreate(): UseMutationResult<unknown, unknown, TagCreate, unknown> {
    return useProjectTagMutation((tag: TagCreate) => editorService.createProjectTag(tag));
}
